import { Tooltip } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import UsualUpload from '@/pages/pageComponents/AgentUpload/Upload/UsualUpload';
import s from '../style.module.scss';
import { useRef } from 'react';

const MobileUsualSkillFileUpload = (props) => {
    const { setAgentFile, agentFile, setReferences, authTest } = props;
    const canOpen = useRef(false);
    const divRef = useRef();

    const onClick = async (e) => {
        if (!canOpen.current) {
            e.preventDefault();
            e.stopPropagation(); // 阻止事件冒泡到 Upload 组件
            let res = await authTest();
            if (res) {
                canOpen.current = true;
                divRef.current?.click();
            }
        }
    };
    return (
        <>
            <UsualUpload
                setAgentFile={setAgentFile}
                agentFile={agentFile}
                setReferences={setReferences}
                uploadItem={
                    <div onClick={onClick} ref={divRef} style={{ height: 32 }} data-disabled={agentFile.length > 4} className={`${s['plugin-item']}`}>
                        <Tooltip rootClassName="plugin-tooltip" title={null}>
                            <PaperClipOutlined />
                        </Tooltip>
                    </div>
                }
            ></UsualUpload>
        </>
    );
};
export default MobileUsualSkillFileUpload;
